// import React from 'react'

// const Contact = () => {
//   return (
//     <section id='contact us' className='max-w-screen-xl mx-auto w-full h-[800px] pb-20 py-20 text-lightText flex border-b-[1px border-b-black'>
//     <div className='flex flex-col gap-6 font-titleFont'>
//     <h3 className='uppercase text-sm font-light text-designColor tracking-wide'>Reach out</h3>
//     <h1 className='text-5xl text-gray-300 font-bold'>Contact Us</h1>
//     <p> 
//     Lorem ipsum dolor sit amet consectetur adipisicing elit.
//     </p>
//     </div>
//     </section>
//   )
// }

// export default Contact


import React from 'react';

const Contact = () => {
  return (
    <div className="container mx-auto py-12 px-4">
      <h1 className="text-5xl font-bold text-designColor text-center mb-8">Contact Us</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden p-6">
          <h2 className="text-2xl font-bold mb-4">Our Address</h2>
          <p className="text-gray-700 mb-4">
            Ray Lab, A-310, R&D Building<br />
            Indraprastha Institute of Information Technology Delhi<br />
            Okhla Industrial Estate, Phase III<br />
            New Delhi - 110020, India
          </p>
          <h2 className="text-2xl font-bold mb-4">Email</h2>
          <p className="text-gray-700 mb-4">
            Reach out to our principal investigator and head of lab, Arjun Ray, at{' '}
            <a href="mailto:arjun@iiitd.ac.in" className="text-blue-500 hover:underline">arjun@iiitd.ac.in</a>.
          </p>
          <h2 className="text-2xl font-bold mb-4">More Information</h2>
          <p className="text-gray-700 mb-4">
            Learn more about our PI <a href="https://www.iiitd.ac.in/arjun" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">here</a>.
          </p>
        </div>
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          <iframe
            title="RayLab Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56076.78719679263!2d77.19197681849698!3d28.5457546806382!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce3e45d85d3e3%3A0x691393414902968e!2sIIIT-Delhi%20R%26D%20Building!5e0!3m2!1sen!2sin!4v1719647511661!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            className="rounded-lg"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact;